import type {
    AiTrackerReportsSourceAnalysisBrandInCitationsCompetitorBenchmark,
    AiTrackerReportsSourceAnalysisCitationsCompetitorBenchmark,
} from "@similarweb/pro-api-client";
import type { AreaGraphProps } from "@similarweb/pro-logic-components/dist/graphs";

import type {
    IBrandInCitationsOverview,
    ICitationsDailyData,
    ICitationsOverview,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/types";
import type { DatesRange } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import { BRAND_IN_CITATIONS_MAX_WINDOW_DAYS } from "./consts";

export const getGraphDataFromArray = (
    dailyDataArray: ICitationsDailyData[],
    name: string,
): AreaGraphProps<unknown>["data"] | null => {
    if (!dailyDataArray || !name) {
        return null;
    }

    return [
        {
            name,
            id: name,
            visible: true,
            data: dailyDataArray.map((item) => [new Date(item.date ?? "").getTime(), item.value]),
        },
    ];
};

type CitationsOverviewWithCoreAverage = ICitationsOverview & {
    competitorBenchmark: AiTrackerReportsSourceAnalysisCitationsCompetitorBenchmark & { influenceScoreAvg: number };
};

export const hasInfluenceCoreAverage = (
    data: ICitationsOverview | undefined,
): data is CitationsOverviewWithCoreAverage => data?.competitorBenchmark?.influenceScoreAvg != null;

type BrandInCitationsOverviewWithCoreAverage = IBrandInCitationsOverview & {
    competitorBenchmark: AiTrackerReportsSourceAnalysisBrandInCitationsCompetitorBenchmark & {
        brandInCitationsScoreAvg: number;
    };
};

export const hasBrandInCitationsCoreAverage = (
    data: IBrandInCitationsOverview | undefined,
): data is BrandInCitationsOverviewWithCoreAverage => data?.competitorBenchmark?.brandInCitationsScoreAvg != null;

export const getBrandInCitationsDateRange = ({ from, to }: DatesRange): DatesRange => {
    const earliestAllowedStart = to.subtract(BRAND_IN_CITATIONS_MAX_WINDOW_DAYS - 1, "day");
    return {
        from: from.isAfter(earliestAllowedStart) ? from : earliestAllowedStart,
        to,
    };
};
